import { Wrapper, Header, Section, Timeslots, Cleanstate, Timeslot, AvailabilityIndicator } from './styles'

Wrapper.Header = Header
Wrapper.Cleanstate = Cleanstate
Wrapper.Section = Section
Wrapper.Timeslots = Timeslots
Wrapper.Timeslot = Timeslot
Wrapper.AvailabilityIndicator = AvailabilityIndicator

export default Wrapper
